import * as swcHelpers from '@swc/helpers';
import { isDeliveryIntervalValid, isConfiguratorValid } from './helpers.js';

const reducer = (state, action)=>{
    switch(action.type){
        case 'setPurchaseType':
            {
                const { purchaseType  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        purchaseType
                    })
                });
            }
        case 'setDeliveryInterval':
            {
                const { deliveryInterval  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        subscriptionPurchaseConfigurations: swcHelpers.objectSpread({}, state.configurations.subscriptionPurchaseConfigurations, {
                            deliveryInterval
                        })
                    }),
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        deliveryInterval: {
                            isValid: true,
                            showError: false
                        }
                    })
                });
            }
        case 'setQuantity':
            {
                const { quantity  } = action.payload;
                return swcHelpers.objectSpread({}, state, {
                    configurations: swcHelpers.objectSpread({}, state.configurations, {
                        quantity
                    })
                });
            }
        case 'updateIsConfiguratorValid':
            {
                const isConfiguratorValid$1 = isConfiguratorValid(state);
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        isConfiguratorValid: isConfiguratorValid$1
                    })
                });
            }
        case 'updateAllValidations':
            {
                const isDeliveryIntervalValid$1 = isDeliveryIntervalValid(state);
                const isValid = isConfiguratorValid(state);
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        isConfiguratorValid: isValid,
                        deliveryInterval: swcHelpers.objectSpread({}, state.configurator.deliveryInterval, {
                            isValid: isDeliveryIntervalValid$1
                        })
                    })
                });
            }
        case 'triggerErrors':
            {
                const { isConfiguratorValid , invalidSubmissionsCount: previousCount , deliveryInterval ,  } = state.configurator;
                const newCount = (previousCount || 0) + 1;
                if (isConfiguratorValid) {
                    return state;
                }
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: newCount,
                        deliveryInterval: swcHelpers.objectSpread({}, deliveryInterval, {
                            showError: (deliveryInterval === null || deliveryInterval === void 0 ? void 0 : deliveryInterval.isValid) === false
                        })
                    })
                });
            }
        case 'resetErrors':
            {
                return swcHelpers.objectSpread({}, state, {
                    configurator: swcHelpers.objectSpread({}, state.configurator, {
                        invalidSubmissionsCount: undefined,
                        deliveryInterval: swcHelpers.objectSpread({}, state.configurator.deliveryInterval, {
                            showError: false
                        })
                    })
                });
            }
        default:
            return state;
    }
};

export { reducer };
//# sourceMappingURL=reducer.js.map
